import { useContext } from 'react';
import { __RouterContext } from 'react-router';

export default function useRouter() {
  const { location, match, history } = useContext(__RouterContext);
  const { pathname } = location;
  const { push } = history;
  return { location, match, history, pathname, push };
}
